/* ============================================================
   FW26 — Size filter grouping

   A collection legitimately mixes sizing systems: Women runs 34–42 on
   tailoring and XS–XL on knitwear; Men runs 44–52 and XS–XL. Shopify
   emits every value of the "Size" option as one flat list, so the two
   systems run together and read as noise.

   The Row solves this with plain sub-labels above each run ("Ready to
   Wear (Alpha)", "Shoes (IT)", "Ready to Wear (US)"). This does the
   same: it inserts "Alpha" and "Numeric" headings into the Size list.

   Deliberately non-destructive — it only INSERTS label nodes, never
   reorders or moves the pills, so the theme's show-more refs and
   keyboard handlers keep working. No-ops when a collection has only one
   sizing system (nothing to disambiguate) or when Size isn't filterable.
   ============================================================ */
(() => {
  const ALPHA = /^(XXS|XS|S|M|L|XL|XXL|3XL)$/i;
  const LABELS = { alpha: 'Alpha', numeric: 'Numeric' };

  const labelFor = (input) => (input.dataset.label || input.value || '').trim();

  const makeLabel = (text, tag) => {
    const node = document.createElement(tag);
    node.className = 'rp-size-group-label';
    node.setAttribute('role', 'presentation');
    node.textContent = text;
    return node;
  };

  const groupList = (list) => {
    if (list.dataset.rpSizeGrouped === '1') return;

    const probe = list.querySelector('input[name="filter.v.option.size" i]');
    if (!probe) return;

    // Each value sits in its own list item; keep them exactly where they are.
    const items = Array.from(list.children).filter((child) =>
      child.querySelector('input[name="filter.v.option.size" i]')
    );
    if (items.length < 2) return;

    const isAlpha = (item) =>
      ALPHA.test(labelFor(item.querySelector('input[name="filter.v.option.size" i]')));

    const firstAlpha = items.find(isAlpha);
    const firstNumeric = items.find((item) => !isAlpha(item));

    // Only worth labelling when both systems are actually present.
    if (!firstAlpha || !firstNumeric) return;

    const tag = items[0].tagName === 'LI' ? 'li' : 'div';
    list.insertBefore(makeLabel(LABELS.alpha, tag), firstAlpha);
    list.insertBefore(makeLabel(LABELS.numeric, tag), firstNumeric);
    list.dataset.rpSizeGrouped = '1';
  };

  const run = () => {
    document.querySelectorAll('.facets__inputs-list').forEach(groupList);
  };

  const schedule = (() => {
    let queued = false;
    return () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        run();
      });
    };
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  // The facets section re-renders on every filter/sort change; re-label it.
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
